import * as React from "react";
import { Icon, MenuItem } from "@chakra-ui/react";
import { IoTrashOutline } from "react-icons/io5";
import { Modal } from "components";
import { useDelete } from "./duck";

const Remove: React.FC = () => {
  const { onConfirm, names } = useDelete();

  return (
    <Modal.Confirm
      onConfirm={onConfirm}
      confirmText="Remove"
      successMessage={
        names.length > 1
          ? `Anesthetic Protocols ${names.join(", ")} are deleted successfully.`
          : `Anesthetic Protocol ${names[0]} is deleted successfully.`
      }
      title="Remove Anesthetic Protocol"
      body={`Are you sure you want to remove ${names.join(
        ", "
      )}? You can’t undo this action afterwards.`}
    >
      <MenuItem
        py={2.5}
        lineHeight={5}
        color="red.600"
        fontSize="sm"
        icon={<Icon as={IoTrashOutline} boxSize="16px" display="block" />}
      >
        Remove
      </MenuItem>
    </Modal.Confirm>
  );
};

export default Remove;
